<template>
    <div v-if="user_admin" class="animated fadeIn container-fluid">

        <b-row>
            <b-col md=2 sm=6>
                <div>{{ $t('n.crop') }}</div>
                <b-form-select v-model="selected_crop" class="select-list">
                    <option :value="null" disabled>{{ $t('menu.select') }} {{ $t('n.crop') }}</option>
                    <option v-for="(item, idx_cr) in list_crops" :key="'crop-' + idx_cr" :value="item" class="radio-unit">
                        {{ item.value }} - {{ item.name }}
                    </option>
                </b-form-select>
            </b-col>
            <b-col md=2 sm=6>
                <div>{{ $t('n.variety') }}</div>
                <b-form-select v-model="selected_cultivar" class="select-list">
                    <option :value="null" disabled>{{ $t('menu.select') }} {{ $t('n.variety') }}</option>
                    <option v-for="(item, idx_cu) in list_cultivars" :key="'cultivar-' + idx_cu" :value="item" class="radio-unit">
                        {{ item.cultivar_code }} - {{ item.name }}
                    </option>
                </b-form-select>
            </b-col>
            <b-col md=3 sm=6>
                <div>{{ $t('menu.current_growth_stage') }}</div>
                <b-form-select v-model="selected_stage" class="select-list">
                    <option :value="null" disabled>{{ $t('menu.select') }} {{ $t('menu.current_growth_stage') }}</option>
                    <option v-for="(item, idx_st) in list_stages" :key="'stage-' + idx_st" :value="item" class="radio-unit">
                        {{ item.value }} - {{ item.name }}
                    </option>
                </b-form-select>
            </b-col>
            <b-col md=3 sm=6>
                <div>{{ $t('menu.stress') }}</div>
                <b-form-select v-model="selected_alertCode" class="select-list">
                    <option :value="null" disabled>{{ $t('menu.select') }} {{ $t('menu.stress') }}</option>
                    <option v-for="(item, idx_ac) in list_statusCodes" :key="'alertCode-' + idx_ac" :value="item" class="radio-unit">
                        {{ item.value }} - {{ item.name }}
                        <span v-if="item.rule">　*</span>
                        <span v-if="item.is_default">　* ( use default )</span>
                    </option>
                </b-form-select>
            </b-col>
        </b-row>

        <hr>
        
        <div>
            <div v-if="selected_crop"       class="badge-normal badge-green-apple">{{ selected_crop.value }} - {{ selected_crop.name }}</div>
            <div v-if="selected_cultivar"   class="badge-normal badge-green-apple">{{ selected_cultivar.cultivar_code }} - {{ selected_cultivar.name }}</div>
            <div v-if="selected_stage"      class="badge-normal badge-green-apple">{{ selected_stage.value }} - {{ selected_stage.name }}</div>
            <div v-if="selected_alertCode"  class="badge-normal">
                <b-button type="button"
                        :class="'block-text btn-stress btn-stress_' + selected_alertCode.value" >
                        <i :class="$tools.style.classStressIcon( selected_alertCode.value, 'block-text' )"></i>{{ $t('stress.' + selected_alertCode.value) }}
                </b-button>
                <!-- <span class="badge-normal badge-green-apple">{{ selected_alertCode.value }} - {{ selected_alertCode.name }}</span> -->
                <b-badge v-if="selected_alertCode.rule" variant="info">已設定規則</b-badge>
                <b-badge v-if="selected_alertCode.is_default" variant="warning">目前套用 default 規則</b-badge>
                <b-badge v-if="selected_alertCode.updated_at" variant="light" class="badge-normal">
                    更新時間({{ timezone }})：{{ selected_alertCode.updated_at }}
                </b-badge>
            </div>
        </div>
        
        <div v-if="selected_alertCode">
            
            <div v-if="saved_rule">
                <h4 class="header-sub">
                    已儲存規則
                    <BtnCopyToClipboard :copy_content="JSON.stringify( saved_rule )" :btn_text="' copy rule'" :tooltip_text="'copy json string'"
                                        btn_style="small" :btn_variant="'outline-warning'">
                    </BtnCopyToClipboard>
                </h4>
                <div id="saved-area" class="testing-area proj-toolbox-area">

                    <div class="proj-toolbox-body text-left">逆境規則邏輯預覽</div>
                    <div class="json-visual-line">
                        <div v-html="saved_rule_html"></div>
                    </div>
                    <br>
                    <div class="proj-toolbox-body text-left">JSON 邏輯</div>
                    <div class="area-code">{{ show_jsonString( saved_rule ) }}</div>
                    <br>
                    <!-- 按鈕列 -->
                    <div class="text-right">
                        <div class="row-function">
                            <!-- 刪除判斷規則 -->
                            <b-button id="button-show" class="btn px-4 btn-upload"
                                        @click="delete_rule"
                                        variant="outline-dark"
                                        :disabled="! saved_rule" >
                                    <i class="fa fa-trash block-text"></i> 刪除此逆境規則
                            </b-button>
                        </div>
                    </div>

                </div>
                
            </div>


            <h4 class="header-sub">輸入/修改區域</h4>
            <div id="input-area" class="proj-toolbox-area">
                
                <div class="proj-toolbox-body text-left">新增判斷規則</div>
                <div>
                    <p class="proj-toolbox-body text-left compute-description">
                        # 輸入範例：<br>
                        [ 單規則：只有一邊填數字、右邊符號選擇 = 按鈕 ]　EX.　35 >= {{ $t('menu.sensor_parameter') }} ,　{{ $t('menu.sensor_parameter') }} > 0　... etc.<br>
                        [ 群組規則 AND：左邊數值 ＞ 右邊數值 ]　EX.　40 > {{ $t('menu.sensor_parameter') }} >=10 ,　35 >= {{ $t('menu.sensor_parameter') }} > 10　... etc.<br>
                        [ 群組規則 OR：左邊數值 ＜ 右邊數值 ]　 EX.　4  > {{ $t('menu.sensor_parameter') }} >=10 ,　5 >= {{ $t('menu.sensor_parameter') }} > 10　... etc.
                    </p>
                    
                    <!-- 左邊數值 -->
                    <div class="select-compute">
                        <b-form-input type="number" class="form-control"
                                    step="0.0001" max="9999999" min="0"
                                    v-model.number="input_computeSign_left" />
                    </div>
                    <!-- 左邊邏輯判斷符號 -->
                    <div class="select-compute">
                        <b-form-radio-group v-model="selected_computeSign_left" :plain="true" buttons>
                            <b-form-radio v-for="(item, idx_cs) in list_computeSign_left" :key="idx_cs"
                                :value="item.value" :button-variant="item.buttonVariant">
                                {{ item.value }}</b-form-radio>
                        </b-form-radio-group>
                    </div>
                    <!-- 中間感測器參數 -->
                    <div class="select-compute">
                        <b-form-select v-model="selected_sensorParam" class="">
                            <option :value="null" disabled>{{ $t('menu.select') }} {{ $t('menu.sensor_parameter') }}</option>
                            <option v-for="(item, idx_sp) in list_sensorParams" :key="'sensorParams-' + idx_sp" :value="item" class="radio-unit">
                                {{ item.value }} - {{ item.name }}
                            </option>
                        </b-form-select>
                    </div>
                    <!-- 右邊邏輯判斷符號 -->
                    <div class="select-compute">
                        <b-form-radio-group v-model="selected_computeSign_right" :plain="true" buttons>
                            <b-form-radio v-for="(item, idx_cs) in list_computeSign_right" :key="idx_cs"
                                :value="item.value" :button-variant="item.buttonVariant">
                                {{ item.value }}</b-form-radio>
                        </b-form-radio-group>
                    </div>
                    <!-- 右邊數值 -->
                    <div class="select-compute">
                        <b-form-input type="number" class="form-control"
                                    step="0.0001" max="9999999" min="0"
                                    v-model.number="input_computeSign_right" />
                    </div>
                    <div class="select-compute">
                        <!-- 新增判斷規則 -->
                        <b-button id="button-show" class="btn btn-warning px-4 btn-upload"
                                    @click="createRule"
                                    :disabled="checkDisabled_computeSign" >
                                <i class="fa fa-plus block-text"></i> 增加判斷規則
                        </b-button>
                    </div>
                </div>

                <br>
                
                <div class="proj-toolbox-body text-left">
                    已產生判斷規則
                    <b-button :variant="(btn_show_json ? '': 'outlint-') + 'dark'"
                            class="btn-show-toggle"
                            @click=" btn_show_json = ! btn_show_json ">
                            <i class="fa fa-reorder"></i> JSON
                    </b-button>
                    <b-badge variant="warning">感測器參數名稱</b-badge>: 基礎規則(黃色)
                    <b-badge variant="secondary">感測器參數名稱</b-badge>: 複合規則(灰色)
                </div>
                <b-form-group>
                    <b-form-checkbox-group name="checkbox_created_rules" v-model="selected_rules" stacked>
                        <template v-for="(item, idx_rule) in list_created_rules">
                            <div v-if="item.param" :key="'rule-' + idx_rule">
                                <b-form-checkbox :value="item.key">
                                    Rule {{ idx_rule + 1 }} <b-badge :variant="( item.is_group ? 'secondary' : 'warning' )">{{ item.param_name }}</b-badge> ：
                                    <!-- {{ item.math_string }} -->
                                    <div class="show-math-string" v-html="json_recursive_to_mathString(item.json)"></div>
                                    <b-button :id="'x-btn-' + idx_rule" class="btn-delete" variant="outline-dark"
                                            @click="delete_rule_from_list(list_created_rules, idx_rule); selected_rules = [];">
                                            X
                                            <!-- Delete -->
                                    </b-button>
                                    <b-tooltip :target="'x-btn-' + idx_rule" placement="right">
                                        <strong>Delete</strong> this rule
                                    </b-tooltip>
                                </b-form-checkbox>
                                <div v-if ="btn_show_json" class="area-show-toggle-context">
                                    {{ show_jsonString( item.json ) }}
                                </div>
                            </div>
                        </template>
                    </b-form-checkbox-group>
                </b-form-group>
                <template v-if="list_created_rules.length == 0">
                    <b-row>
                        <b-col md=6>
                            <NoData :showIcon="true" :showInfo="'無判斷規則'" align="center"></NoData>
                        </b-col>
                    </b-row>
                </template>
                <div v-else>
                    <b-button class="btn px-4 btn-option btn-outline-blue btn-upload" variant="outline-info"
                        @click="do_checkbox_selector_action('select group')">
                        選取所有複合規則
                    </b-button>
                    <b-button class="btn px-4 btn-option btn-outline-blue btn-upload" variant="outline-info"
                        @click="do_checkbox_selector_action('select unit')">
                        選取所有基礎規則
                    </b-button>
                    <b-button class="btn px-4 btn-option btn-outline-blue btn-upload" variant="outline-info"
                        @click="do_checkbox_selector_action('select all')">
                        全部選取
                    </b-button>
                    <b-button class="btn px-4 btn-option btn-outline-blue btn-upload" variant="outline-info"
                        @click="do_checkbox_selector_action('deselect all')">
                        取消選取
                    </b-button>
                    <b-button class="btn px-4 btn-option btn-upload" variant="outline-dark"
                        @click="do_checkbox_selector_action('delete selected')">
                        刪除選擇的規則
                    </b-button>
                </div>
                <div class="select-compute">
                    <!-- 新增規則群組 -->
                    <b-button id="button-show" class="btn btn-warning px-4 btn-upload"
                                @click="create_selected_rules_to_list(list_created_rules, selected_rules, 'and'); selected_rules=[];"
                                :disabled="checkDisabled_groupSign" >AND
                    </b-button>
                    <b-button id="button-show" class="btn btn-warning px-4 btn-upload"
                                @click="create_selected_rules_to_list(list_created_rules, selected_rules, 'or'); selected_rules=[];"
                                :disabled="checkDisabled_groupSign" >OR
                    </b-button>
                    <!-- 設為最終規則 -->
                    <b-button id="button-show" class="btn btn-info px-4 btn-upload"
                                @click="set_finalRule"
                                :disabled="checkDisabled_finalSign" >設定為此規則為最終逆境規則
                    </b-button>
                </div>
                
                <br><br>

                <b-row>
                    <b-col md=6>

                        <div class="proj-toolbox-body text-left">最終逆境規則：邏輯預覽</div>
                        <div v-if="final_rule">
                            <div class="json-visual-line">
                                <div v-html="final_json_html"></div>
                            </div>
                        </div>
                        <template v-else>
                            <NoData :showIcon="true" :showInfo="'無規則'" align="center"></NoData>
                        </template>

                    </b-col>
                    <b-col md=6 v-if="final_rule">

                        <div class="proj-toolbox-body text-left">最終逆境規則：JSON ( 要回傳給後端的規則字串：雙引號須加上\ )</div>
                        <div class="area-code">{{ show_jsonString( final_rule.json ) }}</div>

                    </b-col>
                </b-row>
                
                <br>

                <!-- 更新按鈕列 -->
                <div class="text-right">

                    <div class="row-function">
                        <b-form-checkbox v-model="is_display" :value="true" :unchecked-value="false">顯示在儀表板</b-form-checkbox>
                    </div>
                    <div class="row-function">
                        <b-form-checkbox v-model="is_alert" :value="true" :unchecked-value="false"
                                         :disabled="disabled_is_alert">計算預警</b-form-checkbox>
                    </div>
                    <div class="row-function">
                        <b-form-checkbox v-model="is_stress" :value="true" :unchecked-value="false">計算逆境</b-form-checkbox>
                    </div>

                    <!-- 持續時間：小時(整數) -->
                    <div v-if="selected_alertCode && selected_alertCode.value[0] == 'S'" class="row-function">
                        <div class="input-time">持續時間：</div>
                        <div class="input-time">
                            <b-form-text id="inputLiveHelp">單位： 小時 (整數)</b-form-text>
                            <b-form-input type="number" class="form-control"
                                        min="0" :max="input_max_time"
                                        aria-describedby="inputLiveHelp"
                                        v-model.number="input_observation_time" />
                        </div>
                    </div>

                    <div class="row-function">
                        <!-- 新增判斷規則 -->
                        <b-button v-if="selected_alertCode.rule" id="button-show" class="btn btn-success px-4 btn-upload"
                                    @click="update_rule('update')"
                                    :disabled="checkDisabled_update" >
                                <i class="fa fa-upload block-text"></i> 更新規則至此逆境狀態
                        </b-button>
                        <b-button v-else id="button-show" class="btn btn-success px-4 btn-upload"
                                    @click="update_rule('create')"
                                    :disabled="checkDisabled_update" >
                                <i class="fa fa-upload block-text"></i> 建立新規則至此逆境狀態
                        </b-button>
                    </div>
                </div>

            </div>


            <h4 class="header-sub">測試區域</h4>
            <div id="testing-area" class="testing-area proj-toolbox-area">
                
                <div class="proj-toolbox-body text-left">
                測試區域
                </div>
                
            </div>


            <h4 class="header-sub">直接貼上 json 規則</h4>
            <div id="paste-area" class="paste-area proj-toolbox-area">
                
                <div class="proj-toolbox-body text-left">
                    <b-textarea v-model="input_pasted_json" :rows="6"></b-textarea>
                    
                    <!-- 新增判斷規則 -->
                    <b-button v-if="selected_alertCode.rule" id="button-show" class="btn btn-success px-4 btn-upload"
                                @click="update_rule('update', true)"
                                :disabled="checkDisabled_patse" >
                            <i class="fa fa-upload block-text"></i> 更新規則至此逆境狀態
                    </b-button>
                    <b-button v-else id="button-show" class="btn btn-success px-4 btn-upload"
                                @click="update_rule('create', true)"
                                :disabled="checkDisabled_patse" >
                            <i class="fa fa-upload block-text"></i> 建立新規則至此逆境狀態
                    </b-button>
                </div>
                
            </div>

        </div>


    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import NoData from '@/views/components/NoData'
    import BtnCopyToClipboard from '@/views/components/Button_CopyToClipboard'

    const example_alert_logic_A001 = {
        "and": [
            {
                "and": [
                    { "==": [ { "var": "rainfalls" }, 16 ] },
                ]
            },
            {
                "and": [
                    { ">": [ { "var": "rain_rate" }, 16 ] },
                    { "==": [ { "var": "rain_rate" }, 16 ] }
                ]
            },
            {
                "and": [
                    { "<": [ { "var": "wind_speed" }, 16 ] },
                    { "==": [ { "var": "wind_speed" }, 32 ] }
                ]
            },
            {
                "and": [
                    { ">": [ { "var": "air_temperature" }, 16 ] },
                    { "<": [ { "var": "air_temperature" }, 32 ] }
                ]
            },
            {
                "and": [
                    { ">": [ { "var": "soil_temperature" }, 20 ] },
                    { "<": [ { "var": "soil_temperature" }, 30 ] }
                ]
            },
            {
                "and": [
                    { ">": [ { "var": "soil_conductivity" }, 0 ] },
                    { "<": [ { "var": "soil_conductivity" }, 2 ] }
                ]
            },
            {
                "and": [
                    { ">": [ { "var": "soil_ph" }, 4.5 ] },
                    { "<": [ { "var": "soil_ph" }, 6 ] }
                ]
            },
            {
                "or": [
                    { ">": [ { "var": "air_co2" }, 10 ] },
                    { "<": [ { "var": "air_co2" }, 6 ] }
                ]
            }
        ]
    }

    export default {
        components: {
            NoData,
            BtnCopyToClipboard,
        },
        data () {
            return {

                loading: false,
                timezone: 'Asia/Taipei',
                btn_show_json: false,

                selected_crop: null,
                selected_cultivar: null,
                selected_stage: null,
                selected_alertCode: null,

                disabled_is_alert: false,

                // 判斷規則：產生
                rule_counter: 0,
                selected_sensorParam: null,
                list_computeSign_left: [
                    // { value: '<', buttonVariant: 'outline-success' },
                    // { value: '<=', buttonVariant: 'outline-success' },
                    // { value: '=', buttonVariant: 'outline-success' },
                    { value: '>=', buttonVariant: 'outline-success' },
                    { value: '>', buttonVariant: 'outline-success' },
                ],
                list_computeSign_right: [
                    // { value: '<', buttonVariant: 'outline-success' },
                    // { value: '<=', buttonVariant: 'outline-success' },
                    { value: '>=', buttonVariant: 'outline-success' },
                    { value: '>', buttonVariant: 'outline-success' },
                    { value: '=', buttonVariant: 'outline-success' },
                ],
                selected_computeSign_left: '>',
                selected_computeSign_right: '>',
                input_computeSign_left: undefined,
                input_computeSign_right: undefined,
                created_rules: {},
                list_created_rules: [],

                // 判斷規則：合併
                selected_rules: [],
                final_rule: undefined,
                final_json_html: '',

                // 其他設定
                input_max_time: 512, // const
                input_observation_time: 0,
                is_display: false,
                is_alert: false,
                is_stress: false,

                // 複製規則的 json
                input_pasted_json: undefined,

                // 後端撈取到的規則
                saved_rule_html: '',
                saved_rule: undefined, //example_alert_logic_A001,// undefined,
            }
        },
        mounted () {
            this.$store.commit('standard/clearStatusRules');
            this.get_CropInfo();
        },
        computed: {
            ...mapState({
                'language': state => state.user.language,
                'user_admin': state => state.user.is_admin,
                'list_crops': state => state.cropperiod.list_crops,
                'list_cultivars': state => state.cropperiod.list_cultivars,
                'list_stages': state => state.cropperiod.list_stages,
                'list_statusCodes': state => state.standard.list_statusCodes,
                'list_sensorParams': state => state.device.list_sensorParams,
            }),

            checkDisabled_inquire () {
                if ( this.loading == true )      return true;
                if ( ! this.selected_crop )      return true;
                if ( ! this.selected_cultivar )  return true;
                if ( ! this.selected_stage )     return true;
                if ( ! this.selected_alertCode ) return true;
                return false;
            },

            checkDisabled_computeSign () {
                if ( ! this.selected_sensorParam )       return true;
                if ( ! this.selected_computeSign_left )  return true;
                if ( ! this.selected_computeSign_right ) return true;

                if ( this.input_observation_time > this.input_max_time ) return true;

                if ( this.input_computeSign_left || this.input_computeSign_right ) return false; // 其中一邊有數字就 OK
                return true;
            },

            checkDisabled_groupSign () {
                if ( this.selected_rules.length > 1 ) return false;
                return true;
            },

            checkDisabled_finalSign () {
                if ( this.selected_rules.length == 1 ) return false;
                return true;
            },

            checkDisabled_update () {
                if ( this.final_rule ) return false;
                return true;
            },
            
            checkDisabled_patse () {
                if ( this.input_pasted_json == undefined )  return true;
                if ( this.input_pasted_json == '' )         return true;
                return false;
            },
        },
        watch: {

            // 偵測到 [ 語言 ] 變動就更新作物清單
            language() {
                
                this.selected_crop          = null;
                this.selected_cultivar      = null;
                this.selected_stage         = null;
                this.selected_alertCode     = null;
                this.selected_sensorParam   = null;

                this.get_CropInfo();
                // if (this.selected_crop) { this.get_CropInfo( this.selected_crop.value); }
            },

            selected_crop() {
                this.$store.commit('standard/clearStatusRules');
                this.reset_LogicEditor();
                this.selected_cultivar = null;
                if (this.selected_crop) { this.get_CropInfo( this.selected_crop.value ); }
            },

            selected_cultivar() {
                this.$store.commit('standard/clearStatusRules');
                this.reset_LogicEditor();
                this.selected_stage = null;
                if (this.selected_cultivar) { this.get_GrowthStages(); }
            },

            selected_stage() {
                this.$store.commit('standard/clearStatusRules');
                this.reset_LogicEditor();
                this.selected_alertCode = null;
                if (this.selected_stage) { this.get_StatusRule(); }
            },

            selected_alertCode(val) {
                this.reset_LogicEditor();
                if (val)
                {
                    this.saved_rule = val.rule;
                    this.set_savedRule();

                    this.input_observation_time = val.observation_time;
                    this.is_display = val.is_display;

                    if (val.value == 'A001')
                    {
                        this.is_alert = false;
                        this.disabled_is_alert = true;
                    }
                    else
                    {
                        this.is_alert = val.is_alert;
                        this.disabled_is_alert = false;
                    }
                    this.is_stress  = val.is_stress;
                }
            },

        },
        methods: {

            reset_LogicEditor ()
            {
                this.selected_sensorParam = null;
                this.selected_computeSign_left = '>';
                this.selected_computeSign_right = '>';
                this.input_computeSign_left = undefined;
                this.input_computeSign_right = undefined;
                this.input_observation_time = 0;

                this.created_rules = {};
                this.list_created_rules = [];

                // 判斷規則：合併
                this.selected_rules = [];
                this.final_rule = undefined;
                this.final_json_html = '';

                // 複製規則的 json
                this.input_pasted_json = undefined;

                // 後端撈取到的規則
                this.saved_rule_html = '';
                this.saved_rule = undefined;
            },


            // 取得作物&品種清單：
            // 無 cropCode 表示要撈 [ 作物 ] 清單，有 cropCode 表示要撈該作物代碼下的 [ 品種 ] 清單
            get_CropInfo (cropCode = undefined)
            {
                this.loading = true;

                this.$store.dispatch('cropperiod/getCropInfo', {
                        cropCode: cropCode,
                    })
                    .then(res => {
                        this.loading = false;
                    })
                    .catch(err => {
                        // console.log(err);
                        this.loading = false;
                    })
            },

            get_GrowthStages ()
            {
                this.$store.dispatch('cropperiod/getGrowthstages', {
                        cropCode: this.selected_cultivar.crop_code,
                    })
                    .then(res => {})
                    .catch(err => {})
            },

            get_StatusRule ()
            {
                this.$store.dispatch('standard/getStatusRules', {
                        growthStageID:   this.selected_stage.id,

                        // 判斷是否為 default 用的參數
                        cropCode:        this.selected_crop.value,
                        cultivarCode:    this.selected_cultivar.cultivar_code,
                        growthStageCode: this.selected_stage.value,
                        timezone:        this.timezone,
                    })
                    .then(res => {})
                    .catch(err => {})
            },

            getComputeSignLogic (sensorParam, computeSign, computeValue)
            {
                let _logics = [];
                if (computeSign)
                {
                    switch (computeSign)
                    {
                        case '>':
                            _logics = [
                                { '>': [ { 'var': sensorParam }, computeValue ] },
                            ];
                            return _logics;
                        
                        case '>=':
                            _logics = [
                                { '>':  [ { 'var': sensorParam }, computeValue ] },
                                { '==': [ { 'var': sensorParam }, computeValue ] },
                            ];
                            return _logics;
                        
                        case '<':
                            _logics = [
                                { '<':  [ { 'var': sensorParam }, computeValue ] },
                            ];
                            return _logics;
                        
                        case '<=':
                            _logics = [
                                { '<':  [ { 'var': sensorParam }, computeValue ] },
                                { '==': [ { 'var': sensorParam }, computeValue ] },
                            ];
                            return _logics;
                        
                        case '=':
                        case '==':
                            _logics = [
                                { '==': [ { 'var': sensorParam }, computeValue ] },
                            ];
                            return _logics;
                        
                        default:
                            return _logics;
                    }
                }
                return _logics;
            },
            createRule (_sign = 'and')
            {
                let _param = this.selected_sensorParam.value;

                // json object
                let _jsonObject = {};

                // 如果右方計算符號是 "=" 或是 左右兩側數值一樣，就判斷為 "=="
                if ( this.selected_computeSign_right == '=' || ( this.input_computeSign_left == this.input_computeSign_right ) )
                {
                    // 如果右邊是空的，就等於左邊值
                    let _value = ( this.input_computeSign_right != undefined ? this.input_computeSign_right : this.input_computeSign_left )

                    let _ruleObject = this.getComputeSignLogic( _param, '=', _value );
                    _jsonObject = _ruleObject[0];
                }
                else
                {
                    // 在左側的符號為了使用者好懂而排版成 [ 大於 ] 實際上邏輯設定是 [ 小於 ]
                    let _left_sign = '';
                    let _right_sign = this.selected_computeSign_right;
                    if (this.selected_computeSign_left == '>')  _left_sign = '<';
                    else                                        _left_sign = '<=';

                    
                    
                    // 兩邊都有數值
                    if (this.input_computeSign_left && this.input_computeSign_right)
                    {
                        // 如果左邊數字比較小，表示兩者其實是兩個範圍該用 or 連接
                        if (this.input_computeSign_left < this.input_computeSign_right)
                        {
                            _sign = 'or';
                        }
                        else
                        {
                            _sign = 'and';
                        }
                        
                        let _rule_left = {}, _rule_right = {};

                        let _ruleObj_L  = this.getComputeSignLogic( _param, _left_sign, this.input_computeSign_left );
                        if (_left_sign == '<=') { _rule_left['and'] = _ruleObj_L; }
                        else                    { _rule_left        = _ruleObj_L[0]; }

                        let _ruleObj_R = this.getComputeSignLogic( _param, _right_sign, this.input_computeSign_right );
                        if (_right_sign == '>=') { _rule_right['and'] = _ruleObj_R; }
                        else                     { _rule_right        = _ruleObj_R[0]; }

                        _jsonObject[ _sign ] = [];
                        _jsonObject[ _sign ].push( _rule_left );
                        _jsonObject[ _sign ].push( _rule_right );
                    }
                    // 只有左側有數值
                    else if (this.input_computeSign_left)
                    {
                        let _ruleObject = this.getComputeSignLogic( _param, _left_sign, this.input_computeSign_left );

                        if (_left_sign == '<=') { _jsonObject['and'] = _ruleObject; }
                        else                    { _jsonObject        = _ruleObject[0]; }
                    }
                    // 只有右側有數值
                    else if (this.input_computeSign_right)
                    {
                        let _ruleObject = this.getComputeSignLogic( _param, _right_sign, this.input_computeSign_right );
                        
                        if (_right_sign == '>=') { _jsonObject['and'] = _ruleObject; }
                        else                     { _jsonObject        = _ruleObject[0]; }
                    }
                }

                // console.log( _jsonObject );

                this.rule_counter++;
                this.created_rules[ this.rule_counter ] = {
                    key:            this.rule_counter,
                    param:          _param,
                    param_name:     this.selected_sensorParam.name,
                    json:           _jsonObject,
                    is_group:       false,
                }
                this.list_created_rules.push( this.created_rules[ this.rule_counter ] );
            },

            getGroupName_fromList( name_list )
            {
                let _window_size = this.$tools.ui.getWindowSize()
                let _unique_array = []
                let _name = ''

                for (let i = 0; i < name_list.length; i++)
                {
                    if ( _unique_array.indexOf(name_list[i]) == -1 )
                    {
                        _unique_array.push( name_list[i] );
                    }
                }

                for (let i=0; i<_unique_array.length; i++)
                {
                    if ( i > 5 )
                    {
                        _name += ' . ';
                    }
                    else
                    {
                        if ( i > 0 )
                        {
                            _name += ', ';
                        }
                        _name += _unique_array[i];
                    }
                }
                return _name;
            },

            // 產生複合規則，用 and 、 or 串起來
            create_selected_rules_to_list (list, theRules_keys, groupSign = 'and')
            {
                // selected_rules 排序後串起來，當作 rule 名稱
                theRules_keys.sort();
                let _param = theRules_keys.toString();
                let _param_name_list = [];
                let _param_name = '';

                // json object
                let _jsonObject = {};
                _jsonObject[ groupSign ] = [];

                for (let i=0; i<theRules_keys.length; i++)
                {
                    let _rule = this.created_rules[ theRules_keys[i] ];
                    _param_name_list.push( _rule.param_name );
                    
                    _jsonObject[ groupSign ].push( _rule.json );
                }
                _param_name = this.getGroupName_fromList( _param_name_list );

                this.rule_counter++;
                this.created_rules[ this.rule_counter ] = {
                    key:            this.rule_counter,
                    param:          _param,
                    param_name:     _param_name,
                    json:           _jsonObject,
                    is_group:       true,
                }
                this.list_created_rules.push( this.created_rules[ this.rule_counter ] );

                theRules_keys = [];

                return this.rule_counter;
            },

            // 從指定的清單移除規則
            delete_rule_from_list (list, item_index, key = undefined)
            {
                // 尋找已存在的 key 的位置
                if (key)
                {
                    for (let i=0; i<list.length; i++)
                    {
                        if ( list[i].key == key ) item_index = i;
                    };
                }

                if (item_index != undefined)
                {
                    let _key = list[item_index].key;

                    list.splice( item_index, 1 );

                    if ( ! key )
                    {
                        // 單純刪除規則才清空
                        this.created_rules[ _key ] = undefined;

                        if ( list.length == 0 ) this.final_rule = undefined;
                    }
                    if ( this.final_rule && this.final_rule.key == _key ) this.final_rule = undefined;
                }
            },

            do_checkbox_selector_action (type)
            {
                if (type == 'select all')
                {
                    this.selected_rules = [];
                    this.list_created_rules.forEach( _rule => {
                        this.selected_rules.push( _rule.key )
                    })

                }
                else if (type == 'select group')
                {
                    this.selected_rules = [];
                    this.list_created_rules.forEach( _rule => {
                        if ( this.created_rules[ _rule.key ] && this.created_rules[ _rule.key ].is_group == true )
                        {
                            this.selected_rules.push( _rule.key )
                        }
                    })

                }
                else if (type == 'select unit')
                {
                    this.selected_rules = [];
                    this.list_created_rules.forEach( _rule => {
                        if ( this.created_rules[ _rule.key ] && this.created_rules[ _rule.key ].is_group == false )
                        {
                            this.selected_rules.push( _rule.key )
                        }
                    })

                }
                else if (type == 'deselect all')
                {
                    this.selected_rules = [];
                }
                else if (type == 'delete selected')
                {
                    this.selected_rules.forEach( _key => {
                        this.delete_rule_from_list( this.list_created_rules, undefined, _key )
                    })
                    this.selected_rules = [];
                }
            },

            // 指定最終編輯好的規則，可預覽好看懂的 html 結構 & 為更新做準備
            set_finalRule ()
            {
                this.final_rule = this.created_rules[ this.selected_rules[0] ]

                let _rule = this.final_rule.json
                // 判斷如果不是只有一個 'and' 規則，就要在外層再包一層 'and'
                if ( Object.keys( _rule ).length == 1 && _rule['and'] != undefined )
                {
                    // Do Nothing
                }
                else
                {
                    // 因為後端會需要最外層一個 AND 用來拆解，設定為最終規則時就先加上去
                    this.final_rule.json = { 'and': [ this.final_rule.json ] }
                }
                // console.log( this.final_rule.json )
                
                if (this.final_rule && this.final_rule.json)
                {
                    this.final_json_html = this.json_recursive_to_html( this.final_rule.json )
                }
            },

            // 顯示從後端取地的規則邏輯：
            // json_recursive_to_html - 以較好看懂的 html 呈現
            // json_recursive_to_small_rules - 拆解規則
            set_savedRule ()
            {
                if (this.saved_rule)
                {
                    this.saved_rule_html = this.json_recursive_to_html( this.saved_rule )
                    this.json_recursive_to_small_rules( this.saved_rule )
                }
            },

            // 將 [ json 邏輯物件 ] 轉成比較好看懂得 html 顯示
            json_recursive_to_html (_jsonObject)
            {
                let _html = '';
                for ( let _sign in _jsonObject )
                {
                    if ( _jsonObject[ _sign ] && _jsonObject[ _sign ].length > 0 )
                    {
                        switch ( _sign )
                        {
                            case 'and':
                            case 'or':
                                _html += '<div class="json-visual-line" style="margin-left:20px;">' + _sign.toUpperCase() + ' { ';
                                
                                _jsonObject[ _sign ].forEach( _jObject => {
                                    _html += this.json_recursive_to_html( _jObject );
                                });

                                _html += '} </div>';
                                break;

                            case '>':
                            case '<':
                            case '==':
                                _html += '<div class="json-visual-line" style="margin-left:20px;">';
                                _html += _jsonObject[ _sign ][0]['var'] + ' ' + _sign + ' ' +  _jsonObject[ _sign ][1];

                                _html += '</div>';
                                break;
                            default: break;
                        }
                    }
                }
                return _html;
            },

            // 將 [ json 邏輯物件 ] 轉成比較好看懂得 mathString 數學表達 顯示
            json_recursive_to_mathString (_jsonObject)
            {
                let _mathString = '';
                for ( let _sign in _jsonObject )
                {
                    if ( _jsonObject[ _sign ] && _jsonObject[ _sign ].length > 0 )
                    {
                        switch ( _sign )
                        {
                            case 'and':
                            case 'or':
                                
                                let _jsonObj = _jsonObject[ _sign ]
                                for (let i=0; i<_jsonObj.length; i++)
                                {
                                    if (i>0) _mathString += ' ' + _sign + ' ';
                                    _mathString += '( ' + this.json_recursive_to_mathString( _jsonObj[i] ) + ' )';
                                }
                                break;

                            case '>':
                            case '<':
                            case '==':
                                _mathString += '<code>';
                                _mathString += _jsonObject[ _sign ][0]['var'] + ' ' + _sign + ' ' +  _jsonObject[ _sign ][1];

                                _mathString += '</code>';
                                break;
                            default: break;
                        }
                    }
                }
                return _mathString;
            },

            // 根據 感測器參數 code (sensor_param value) 找到對應的感測器參數名稱
            get_sensorParam_name (param)
            {
                let _name = undefined
                this.list_sensorParams.forEach( _sp => {
                    if ( _sp.value == param )
                    {
                        _name = _sp.name;
                    }
                })
                return _name;
            },

            // 將 [ json 邏輯物件 ] 從最底層開始拆解最小元件，並把他 group (and / or) 起來
            json_recursive_to_small_rules (_jsonObject)
            {
                for ( let _sign in _jsonObject )
                {
                    if ( _jsonObject[ _sign ] && _jsonObject[ _sign ].length > 0 )
                    {
                        switch ( _sign )
                        {
                            case 'and':
                            case 'or':
                                if ( _jsonObject[ _sign ][0]['and'] == undefined && _jsonObject[ _sign ][0]['or'] == undefined )
                                {
                                    let _paramList = {}
                                    _jsonObject[ _sign ].forEach( _jObject => {
                                        let _smallSetting = this.json_recursive_to_small_rules( _jObject );
                                        
                                        if (_smallSetting) // [ 感測器參數, 運算符號, 數值 ]
                                        {
                                            this.rule_counter++;
                                            _paramList[ this.rule_counter ] = _smallSetting;
                                        }
                                    });

                                    // 開始建立最小 rule
                                    let _smallRules = [];
                                    for ( let _key in _paramList)
                                    {
                                        // json object
                                        let _ruleObject = {};

                                        _ruleObject = this.getComputeSignLogic( _paramList[_key].param, _paramList[_key].computeSign, _paramList[_key].value );
                                        
                                        this.created_rules[ _key ] = {
                                            key:            _key,
                                            param:          _paramList[_key].param,
                                            param_name:     this.get_sensorParam_name( _paramList[_key].param ),
                                            json:           _ruleObject[0],
                                            is_group:       false,
                                        }
                                        
                                        this.list_created_rules.push( this.created_rules[ _key ] );
                                        _smallRules.push(_key);
                                    }
                                    // console.log(_jsonObject[ _sign ])
                                    // console.log(_smallRules)

                                    // 根據 and / or 設定串接剛剛的小 rule
                                    if ( _smallRules.length > 1 )
                                    {
                                        return this.create_selected_rules_to_list(this.list_created_rules, _smallRules, _sign);
                                    }
                                    else if ( _smallRules.length == 1 )
                                    {
                                        return _smallRules[0];
                                    }
                                }
                                else
                                {
                                    let _groupRules_keys = [];
                                    _jsonObject[ _sign ].forEach( _jObject => {

                                        let _key = this.json_recursive_to_small_rules( _jObject );
                                        
                                        if ( _key != undefined ) _groupRules_keys.push( _key );
                                    });

                                    return this.create_selected_rules_to_list(this.list_created_rules, _groupRules_keys, _sign);
                                    
                                }
                                break;

                            case '>':
                            case '<':
                            case '==':
                                return {
                                        computeSign: _sign,
                                        param:       _jsonObject[ _sign ][0]['var'],
                                        value:       _jsonObject[ _sign ][1],
                                    };
                                break;
                            default: return undefined;
                        }
                    }
                }
            },

            show_jsonString (item)
            {
                let _result = '';
                if (item)
                {
                    _result = JSON.stringify( item );
                    _result = _result.replace(/\[/gi, "\[ ");     // 將所有的 [ 都加上空格
                    _result = _result.replace(/\]/gi, " \]");     // 將所有的 ] 都加上空格
                    _result = _result.replace(/\{/gi, "\{ ");     // 將所有的 { 都加上空格
                    _result = _result.replace(/\}/gi, " \}");     // 將所有的 } 都加上空格
                    _result = _result.replace(/,/gi,  ", ");      // 將所有的 , 都加上空格
                    _result = _result.replace(/:/gi,  ": ");      // 將所有的 : 都加上空格
                }
                // console.log( _result );
                return _result;
            },

            // 刪除後端儲存的規則邏輯
            delete_rule ()
            {
                if ( confirm('確定要刪除嗎? 刪了就沒有了喔QQ') )
                {
                    console.log( '哭哭，刪了就沒有了...' )
                    this.$store.dispatch('standard/deleteStatusRule', { statusRuleID: this.selected_alertCode.id })
                        .then(res => {
                            this.get_StatusRule();
                            this.selected_alertCode = null;
                            this.$toastr.s(this.$t('other.update_succeeded'), '刪除逆境規則');
                        })
                        .catch(err => {
                            this.$toastr.e(this.$t('other.update_failed'), '刪除逆境規則');
                        })
                }
                else
                {
                    console.log( '好險沒刪' )
                }
            },

            // 更新/產生 規則邏輯至後端儲存
            update_rule (action, do_paste = false)
            {
                let _result = undefined;
                if ( do_paste == true && this.input_pasted_json )
                {
                    _result = this.input_pasted_json
                }
                else if ( this.final_rule && this.final_rule.json )
                {
                    let _jsonString = JSON.stringify( this.final_rule.json );
                    _result = _jsonString;
                    // _result = _jsonString.replace(/\"/gi, "\\\"");  // 將所有的 " 都取代為 \"
                    // console.log( _result );
                }

                if ( _result != undefined )
                {
                    let _data = {
                        crop_id:        this.selected_crop.value,
                        cultivar_id:    this.selected_cultivar.cultivar_code,
                        code:           this.selected_alertCode.value,
                        rules:          _result,

                        observation:    this.input_observation_time,
                        isdisplay:      this.is_display,
                        isalert:        this.is_alert,
                        isstress:       this.is_stress,
                    }

                    if (action == 'update')
                    {
                        const options = {
                            method: 'PUT',
                            url: this.$config.getAPI_URL('Update_StatusRules', { statusRuleID: this.selected_alertCode.id }),
                            data: _data
                        }
                        this.$http(options)
                            .then(res => {
                                this.get_StatusRule();
                                this.$toastr.s(this.$t('other.update_succeeded'), '更新逆境規則');
                            })
                            .catch(err => {
                                this.$toastr.e(this.$t('other.update_failed'), '更新逆境規則');
                            })


                    }
                    else if (action == 'create')
                    {
                        const options = {
                            method: 'POST',
                            url: this.$config.getAPI_URL('Create_StatusRules', { growthStageID: this.selected_stage.id }),
                            data: _data
                        }
                        this.$http(options)
                            .then(res => {
                                this.get_StatusRule();
                                this.$toastr.s(this.$t('other.update_succeeded'), '創建逆境規則');
                            })
                            .catch(err => {
                                this.$toastr.e(this.$t('other.update_failed'), '創建逆境規則');
                            })
                    }
                }

            },

        },
    }
</script>


<style lang="scss" scoped>

.proj-toolbox-area
{
    margin-bottom: 35px;
}
.compute-description
{
    font-size: 0.95rem;
    color: #8b9695;
}

.area-code
{
    font-size: 0.9rem;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 10px;
    color: #2c6f4f;

    padding: 15px 20px;
    border-radius: 3px;
    background-color: #d9faea;
}

.show-math-string
{
    display: inline-block;
    margin: 2px 10px;
}

.select-compute
{
    display: inline-block;
    vertical-align: middle;
    margin: 5px;

    .form-control
    {
        width: 110px;
    }
}

.input-time
{
    display: inline-block;
    vertical-align: bottom;
    margin-right: 5px;

}

.row-function
{
    display: inline-block;
    vertical-align: bottom;
    margin-right: 20px;
    margin-bottom: 15px;
    
    .form-control
    {
        width: 110px;
    }
}


.json-visual-line
{
    margin: 5px 5px 5px 20px;
    padding: 5px;
    text-align: left;
    vertical-align: top;
}

</style>

